// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1_KRh","left":"InfoRow_left__3c_3p"};